import { useMemo } from 'react';

const env = (typeof globalThis !== 'undefined' && (globalThis as any).__APP_ENV__) || {};
const tokenKey = (env.tokenKey as string) ?? 'authToken';

export function readAuthToken(): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(tokenKey);
}

/** Lightweight hook to read the auth token once. */
export function useAuthToken(): string | null {
  return useMemo(() => readAuthToken(), []);
}
